import { z } from 'zod';

export const CheckLotteryStatusSchema = z.object({
  phone: z.string().min(1, 'Phone number is required'),
});

export type CheckLotteryStatusFormType = z.infer<
  typeof CheckLotteryStatusSchema
>;
